"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SubscriptionCardGroup = exports.SubscriptionCard = void 0;
const selector_1 = require("@pulse-web-ui/selector");
const react_1 = __importStar(require("react"));
const subscription_card_styles_1 = require("./subscription-card.styles");
require("./subscription-card.types");
const CardGroupContext = react_1.default.createContext({});
exports.SubscriptionCard = (0, react_1.memo)((_a) => {
    var { value, title, subTitle, description, discount, discountBadgeColor, testId = 'subscription-card' } = _a, otherProps = __rest(_a, ["value", "title", "subTitle", "description", "discount", "discountBadgeColor", "testId"]);
    const { name, selectedValue, onChange } = (0, react_1.useContext)(CardGroupContext);
    const selectedCurrentVal = value === selectedValue;
    return (react_1.default.createElement(subscription_card_styles_1.StyledSubscriptionCard, Object.assign({ htmlFor: value, checked: value === selectedValue, "data-testid": `${testId}-${value}-label` }, otherProps),
        react_1.default.createElement("input", { type: "radio", id: value, name: name, value: value, checked: value === selectedValue, onChange: onChange.bind(null, value), "data-testid": `${testId}-${value}-radio` }),
        subTitle && (react_1.default.createElement(subscription_card_styles_1.StyledSubTitleWrapper, null,
            react_1.default.createElement(subscription_card_styles_1.StyledSubTitle, null,
                react_1.default.createElement("span", null, subTitle),
                discount && (react_1.default.createElement(subscription_card_styles_1.StyledDiscountBadge, { discountBadgeColor: discountBadgeColor }, discount))),
            react_1.default.createElement(selector_1.Selector, { checked: selectedCurrentVal, onClick: onChange.bind(null, value) }))),
        react_1.default.createElement(subscription_card_styles_1.StyledTitle, null, title),
        description && react_1.default.createElement(subscription_card_styles_1.StyledDescription, null, description)));
});
exports.SubscriptionCardGroup = (0, react_1.memo)((_a) => {
    var { name, selectedValue, onChange, children } = _a, otherProps = __rest(_a, ["name", "selectedValue", "onChange", "children"]);
    const ctx = { name, selectedValue, onChange };
    return (react_1.default.createElement(CardGroupContext.Provider, { value: ctx },
        react_1.default.createElement(subscription_card_styles_1.StyledSubscriptionCardGroup, Object.assign({}, otherProps), children)));
});
